import { useIsMobile } from "@/hooks/use-mobile";
import { PropsWithChildren } from "react";
import { MobileLayout } from "./MobileLayout";
import { DesktopLayout } from "./DesktopLayout";

export const LayoutSwitcher = ({ children }: PropsWithChildren) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileLayout>{children}</MobileLayout>;
  }
  return <DesktopLayout>{children}</DesktopLayout>;
};
